import {
  createStripeInvoice,
  createStripeSubscription,
  getUser,
} from "@helpers/supabase"
import { redirect } from "react-router-dom"
import { Plan } from "src/types"

export default async function createStripeSubscriptionAction({
  request,
}: {
  request: Request
}) {
  const { currency, fullPrice, nextPriceId, plan, priceId } =
    await getFormValues(request)

  if (!currency || !priceId) return redirect("/checkout/plans")

  const { data: userData } = await getUser()

  const email = userData?.user?.email

  if (!email) return redirect("/checkout/plans")

  const urlSearchParams = new URLSearchParams(request.url.split("?")[1])

  const isOneTime = plan === "one-time"

  const { data } = (
    isOneTime
      ? await createStripeInvoice({ currency, email, priceId })
      : await createStripeSubscription({ currency, email, priceId })
  ) as {
    data: Record<string, string>
  }

  const params: Record<string, string> = {
    client_secret: data.clientSecret,
    currency: data.invoiceCurrency,
    full_price: fullPrice,
    next_price_id: isOneTime ? "" : nextPriceId,
    plan,
    price_id: priceId,
    ...(isOneTime
      ? { payment_intent_id: data.paymentIntentId }
      : { subscription_id: data.subscriptionId }),
  }

  for (const [key, value] of Object.entries(params)) {
    urlSearchParams.append(key, value)
  }

  return redirect("/checkout/payment?" + urlSearchParams.toString())
}

async function getFormValues(request: Request): Promise<{
  currency: string
  fullPrice: string
  nextPriceId: string
  plan: Plan
  priceId: string
}> {
  const formData = await request.formData()

  const { currency, fullPrice, nextPriceId, plan, priceId } =
    Object.fromEntries(formData)

  return { currency, fullPrice, nextPriceId, plan, priceId } as {
    currency: string
    fullPrice: string
    nextPriceId: string
    plan: Plan
    priceId: string
  }
}
